<template>
  <fb-list-body :pager="pager" :showSearchForm="true" :showBtnGroup="false"
                @handlePagerSizeChange="handlePagerSizeChange" @handlePagerIndexChange="handlePagerIndexChange">


    <template slot="search-form">
      <el-form-item class="search-form-item" :label="$t('lang.分类')">
        <el-select :placeholder="$t('lang.全部')" v-model="searchForm.recipeCategoryCode" clearable>
          <el-option v-for="i in categoryList" :key="i.recipeCategoryCode" :label="i.name" :value="i.recipeCategoryCode"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.食谱名称')">
        <el-input :placeholder="$t('lang.食谱名称')" v-model="searchForm.name" clearable></el-input>
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.食谱编号')">
        <el-input :placeholder="$t('lang.食谱编号')" v-model="searchForm.number" clearable></el-input>
      </el-form-item>


      <el-form-item class="search-form-item" label="">
        <el-button size="mini" type="primary" icon="el-icon-search" @click.stop="handleSearch">{{ $t('lang.搜索') }}</el-button>
        <el-button size="mini" type="primary" @click="handleReset">{{ $t('lang.重置') }}</el-button>
        <el-button size="mini" type="danger" @click="handleBatchDelete">{{ $t('lang.全部清除') }}</el-button>
      </el-form-item>

    </template>


    <template slot="table">
      <el-table :data="tableData" @selection-change="handleSelectionChange">

        <el-table-column type="selection" width="50"></el-table-column>

        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="productName" :label="$t('lang.图片')">
          <template slot-scope="scope">
            <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.photo | filterImg(that)"/>

          </template>
        </el-table-column>
        <el-table-column prop="recipeCategoryName" :label="$t('lang.分类')"></el-table-column>
        <el-table-column prop="name" :label="$t('lang.食谱名称')"></el-table-column>
        <el-table-column prop="number" :label="$t('lang.食谱编号')"></el-table-column>
        <el-table-column :label="$t('lang.删除时间')" width="560px">
          <template slot-scope="scope">
            <div style="display: flex;">
              <span>{{ scope.row.removeTimeStr }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column fixed="right" :label="$t('lang.操作')" width="280">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleRecovery(scope.row)" plain  type="primary">{{ $t('lang.恢复') }}</el-button>
            <el-button size="mini" plain type="danger" @click="handleDelete(scope.row)">{{ $t('lang.删除') }}</el-button>
          </template>
        </el-table-column>


      </el-table>

    </template>


  </fb-list-body>
</template>

<script>
import {recipeCategoryList} from "../../js/common";

export default {
  name: "RecyclingList",
  props: {
    timestamp: {
      type: Number,
      default: function () {
        return new Date().getTime()
      }
    },
  },
  data() {
    return {
      api: {
        list: this.$api.recipe.list,
        clear: this.$api.recipe.clear,
        recovery: this.$api.recipe.recovery,
        batchClear: this.$api.recipe.batchClear,
      },
      searchForm: {
        removeStatus: 'REMOVED',
      },
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0
      },
      that: this,
      categoryList: [],
      value: [],
      options: [{
        value: 'zhinan',
        label: '指南',
        children: [{
          value: 'shejiyuanze',
          label: '设计原则',
        }]
      }]
    }
  },
  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    }
  },
  watch: {
    timestamp() {
      this.handleGetData();
    },
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();

      },
      deep: true,
      immediate: true
    },
    "pager.pageSize": {
      handler() {

        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();

      },
      deep: true
    }

  },
  methods: {
    handleRecovery(row) {
      let vm = this;

      vm.$confirm(vm.$t('lang.您现在正在进行恢复操作, 是否继续?'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'success'
      }).then(() => {

        vm.$http.post(vm.api.recovery, vm.$qs.stringify({
          code: row.code
        })).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      })
    },
    handleSearch() {
      this.pager.pageIndex = 1;
      this.pager.pageSize = 10;
      this.pager.itemCount = 0;
      this.handleGetData();
    },
    handleReset() {
      if(Object.keys(this.searchForm).length) {
        this.searchForm = {
          removeStatus: 'REMOVED',
        };
        this.pager.pageIndex = 1;
        this.pager.pageSize = 10;
        this.pager.itemCount = 0;
        this.handleGetData();
      }
    },
    handleDelete(row) {


      let vm = this;

      vm.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(vm.api.clear, vm.$qs.stringify({
          code: row.code
        })).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });

    },
    handleBatchDelete() {


      let vm = this;

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: vm.$t('lang.未选择记录')
        });
        return;
      }


      let codes = [];

      this.selection.forEach((e) => {
        codes.push(e.code);
      });


      this.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(this.api.batchClear, codes).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });


    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleGetData() {
      let vm = this;
      let data = {...this.searchParams};
      data['brandOwnerCode'] = this.$store.state.userInfo['brandOwnerCode'];
      this.$http.post(this.api.list, this.$qs.stringify(data)).then((resp) => {


        for (let key in resp.data.data) {
          if (resp.data.data[key] instanceof Array) {
            vm.tableData = resp.data.data[key];
          }
        }

        vm.tableData.forEach(item => {
          let list = item['supportLangList'];
          item['supportLangList']  = list.map(item => {
            let lang = vm.$store.state.supportLangList.find(lang => item == lang.value);
            return lang;
          })

        })

        //处理分页
        vm.pager.pageIndex = resp.data.data.pager.pageIndex;
        vm.pager.pageSize = resp.data.data.pager.pageSize;
        vm.pager.itemCount = resp.data.data.pager.itemCount;

      })
    }
  },
  async created() {
    this.categoryList = await recipeCategoryList(this);
    console.log('data', this.categoryList)

    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
  }
}
</script>

<style scoped>

</style>
